<ng-template #volumeBarMaxTextTpl>
	<p>100</p>
</ng-template>

<div class="w-full h-full flex flex-col items-start justify-start" #videoWrapper>
	<div class="overflow-hidden w-full h-0 flex items-center justify-start">
		<div #volumeBarMaxText>
			<ng-container [ngTemplateOutlet]="volumeBarMaxTextTpl"></ng-container>
		</div>
	</div>

	<div
		class="media-wrapper overflow-hidden w-full h-full relative [background-color:#000000]"

		[class.allow-hover]="!$hideMouse()"
		[class.show-controls]="$showControls()"
		[style.cursor]="$hideMouse() ? 'none' : null"
		(click)="$event.stopPropagation(); $event.preventDefault(); togglePlay()"
		(dblclick)="$event.stopPropagation(); $event.preventDefault(); toggleFullscreen()"
		(keydown.Space)="$event.stopPropagation(); $event.preventDefault(); togglePlay()"
		(keydown.enter)="$event.stopPropagation(); $event.preventDefault(); togglePlay()"
		(keydown.f)="$event.stopPropagation(); $event.preventDefault(); toggleFullscreen()"
		(keydown.m)="$event.stopPropagation(); $event.preventDefault(); toggleMute()"
		(keydown.arrowUp)="$event.stopPropagation(); $event.preventDefault(); increaseVolume()"
		(keydown.arrowDown)="$event.stopPropagation(); $event.preventDefault(); decreaseVolume()"
		(keydown.arrowLeft)="$event.stopPropagation(); $event.preventDefault(); goBackwards()"
		(keydown.arrowRight)="$event.stopPropagation(); $event.preventDefault(); goForward()"
		(mousemove)="onMouseMove()"
		(mouseleave)="onMouseLeave()"
	>
		<video
			#video
			class="w-full h-full"
			[src]="$fileUrl()"
			loop
			crossorigin="use-credentials"
			(pause)="onPause()"
			(play)="onPlay()"
			(ended)="onEnded()"
			(onloadedmetadata)="onLoadedMetadata()"
			(durationchange)="onDurationChange()"
			(timeupdate)="onTimeUpdate()"
			(volumechange)="onVolumeChange()"
		></video>

		<div
			class="controls-bar py-2 px-3 bottom-0 left-0 gap-2 w-full flex absolute items-center justify-center"
			(click)="$event.stopPropagation()"
		>
			<div class="flex-none gap-0.5 flex items-center justify-start">
				<button commonButtonIcon class="action-button" (click)="togglePlay()">
					<i
						[class.icon-bold-play-media]="!$playing()"
						[class.icon-bold-pause-media]="$playing()"
					></i>
				</button>

				<button commonButtonIcon class="action-button" (click)="goBackwards()">
					<i class="icon-bold-backward-media"></i>
				</button>

				<button commonButtonIcon class="action-button" (click)="goForward()">
					<i class="icon-bold-forward-media"></i>
				</button>

				<div
					class="flex items-center justify-start volume-wrapper"
					[class.show-content]="$draggingVolume()"
					[class.allow-hover]="!$draggingTime()"
					[style.--aux-volume-width.px]="volumeBarMaxText.clientWidth"
				>
					<button commonButtonIcon class="action-button" (click)="toggleMute()">
						<i [class.icon-volume]="!$muted()" [class.icon-volume-muted]="$muted()"></i>
					</button>

					<div class="overflow-hidden flex items-center justify-start volume-content">
						<div class="flex-none gap-1 flex items-center justify-start">
							<div
								#volumeBar
								class="rounded-0.25 flex-none h-0.5 bg-line-230 cursor-pointer flex relative items-center justify-start w-10"

							>
								<div
									class="rounded-0.25 h-full bg-primary"
									[style.width.%]="$volumeToShow()"
								></div>

								<div
									class="rounded-circle w-1.75 h-1.75 bg-primary absolute pointer-events-none top-1/2 [transform:translate(-50%,_-50%)]"

									[style.left.%]="$volumeToShow()"
								></div>
							</div>

							<div class="flex-none flex flex-col items-start justify-start">
								<div class="overflow-hidden h-0 invisible">
									<ng-container
										[ngTemplateOutlet]="volumeBarMaxTextTpl"
									></ng-container>
								</div>
								<p>{{ $volumeToShow() | number : '1.0-0' }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				#timerBar
				class="flex-auto overflow-hidden h-0.75 cursor-pointer rounded-0.375 [background-color:rgba(78,_79,_85,_1)]"

			>
				<div
					class="h-full bg-primary rounded-0.375"
					[style.width.%]="($currentTime() / $maxTime()) * 100"

				></div>
			</div>

			<p class="flex-none">
				<span>{{ $currentTime() | videoPreviewTimestamp }}</span>
				<span>&nbsp;/&nbsp;</span>
				<span>{{ $maxTime() | videoPreviewTimestamp }}</span>
			</p>

			<div class="flex-none gap-0.5 flex items-center justify-start">
				<button commonButtonIcon class="action-button" (click)="toggleFullscreen()">
					@if ($fullscreenEnabled()) {
						<i class="icon-fullscreen-inside"></i>
					} @else {
						<i class="icon-fullscreen-outside"></i>
					}
				</button>
			</div>
		</div>
	</div>
</div>
